import Link from "@/components/link/Link";
import type {
  PortableTextMarkComponent,
  PortableTextMarkComponentProps,
} from "@portabletext/react";
import type { ArbitraryTypedObject } from "@portabletext/types";

const LinkExternal: PortableTextMarkComponent = ({
  value,
  text,
}: PortableTextMarkComponentProps) => {
  const { blank, href } = value as ArbitraryTypedObject;
  const target = blank ? "_blank" : "_self";

  return (
    <Link href={href} target={target} next={false}>
      {text}
    </Link>
  );
};

export default LinkExternal;
